import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.scss']
})
export class ComingSoonComponent implements OnInit {

  constructor(private title:Title,private meta:Meta,private renderer: Renderer2,@Inject(PLATFORM_ID) private platformId: Object) {
    this.setSeoMeta()
   }

  ngOnInit(): void {
  }
    setSeoMeta() {
    const supportedLanguages = ['en', 'fr', 'es', 'pt'];
    let finalUrl = '';

    if (isPlatformBrowser(this.platformId)) {
      const origin = window.location.origin;
      const path = window.location.pathname;
      const parts = path.split('/');

      let lang = 'en'; // Default
      if (supportedLanguages.includes(parts[1])) {
        lang = parts[1];
      }

      // const fullPath = path.replace(/^\/[a-z]{2}/, '');
      // finalUrl = `${origin}/${lang}${fullPath}`;
      const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

    }


    const seoData = {
      title: 'MEDEIL POS Update: New Retail & Pharmacy Features Coming',
      description:
        'Exciting updates are on the way! Discover upcoming MEDEIL retail and pharmacy POS features designed to boost your business and customer experience.',
      image: 'https://www.medeil.com/en/assets/medeil-pharmacy-software.jpg',
      url: finalUrl,
      keywords:
        'coming soon, POS updates, new POS features, retail POS launch, pharmacy POS upgrade, MEDEIL roadmap, business software release, POS innovation'
    };


      // this.seoService.setData(seoData);
      this.title.setTitle(seoData.title);
      const metaTags = [
        { name: 'description', content: seoData.description },
        { name: 'keywords', content: seoData.keywords },
        { property: 'og:title', content: seoData.title },
        { property: 'og:description', content: seoData.description },
        { property: 'og:url', content: seoData.url },
        { property: 'og:type', content: 'website' },
        { property: 'og:image', content: seoData.image }
      ];

      metaTags.forEach(tag => this.meta.updateTag(tag));
    }
setSchema() {
    const schema = {
 "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "MEDEIL POS Update: New Retail & Pharmacy Features Coming",
  "description": "Exciting updates are on the way! Discover upcoming MEDEIL retail and pharmacy POS features designed to boost your business and customer experience.",
  "url": "https://www.medeil.com/en/coming-soon",
  "inLanguage": "en",
  "isPartOf": {
    "@type": "WebSite",
    "name": "MEDEIL",
    "url": "https://www.medeil.com"
  },
  "publisher": {
    "@type": "Organization",
    "name": "MEDEIL",
    "url": "https://www.medeil.com",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.medeil.com/assets/images/logo.png"
    }
  },
  "mainEntity": {
    "@type": "Product",
    "name": "MEDEIL POS",
    "description": "Advanced retail and pharmacy point of sale system with upcoming new features",
    "brand": {
      "@type": "Brand",
      "name": "MEDEIL"
    },
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/PreOrder",
      "url": "https://www.medeil.com/en/coming-soon"
    }
  },
  "potentialAction": {
    "@type": "SignUp",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://www.medeil.com/en/coming-soon#signup",
      "description": "Sign up for early access and updates"
    }
  }

    }
}
}
